/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useContext, Fragment, useState, useEffect } from "react";
import { ContentZoneContext } from "cms/components/context/index";
import { ReactComponent as RecycleSVG } from "assets/images/icons/components/recycle-regular.svg";
import { isGuid } from "utils/empty-exists";
import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import { useAuth } from "cms/auth/hooks/use-auth";

const ComponentReuseIcon = () => {
    // Also see src/cms/components/layout/reuse/banner/component-reuse-banner.jsx
    const { token } = useAuth();
    const { component } = useContext(ContentZoneContext);
    let reuse_count = component?.reuse_count ?? 0;
    let guid = component?.guid;
    
    const [usageCount, setUsageCount] = useState(reuse_count);
    
    /*
         TODO:
             eventually remove this look up.
             reuse_count can be pre-populated to provide usage without a lookup (until you click for more info)
             but having this query here for now fixes cases where the data is not up to date yet
             reuse_count is populated when components are saved.
     */
    useEffect(() => {
        const fetchUsage = async () => {
            if (isGuid(guid)) {
                let _usage = await SimpliCityAdminSDK.component.getComponentUsage(token, guid);
                if (_usage) {
                    setUsageCount(_usage?.length);
                }
            }
        };
        fetchUsage();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [guid]);
    
    return (
        <Fragment>
            {usageCount > 1 &&
                <RecycleSVG />
            }
        </Fragment>
    );
};

ComponentReuseIcon.displayName = "ComponentReuseIcon";
export { ComponentReuseIcon };
